module.exports = __webpack_public_path__ + "img/thumbnail_Takin_m_normal.9007e4d4.png";